import "../assets/style/Footer.css"

const Footer = (props: any) => {

    return (
        <div className="footer">
            <p style={{ fontWeight: '600', fontSize: '14px', margin: '0' }}>No. of Records: {props.totalCount ? props.totalCount : 0}</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                    <label style={{ marginLeft: '10px', marginRight: '10px', fontWeight: '500', }}
                    >Select Limit :</label>
                    <input
                        id="25"
                        type="radio"
                        name="limit"
                        className="custom-radio-button"
                        value={25}
                        defaultChecked
                        onChange={(e: any) => { props.changePaginationLimit(e.target.value) }}
                    />
                    <label htmlFor="25">25</label>
                    <input
                        id="50"
                        type="radio"
                        name="limit"
                        className="custom-radio-button"
                        value={50}
                        onChange={(e: any) => { props.changePaginationLimit(e.target.value) }}
                    />
                    <label htmlFor="50">50</label>
                    <input
                        id="100"
                        type="radio"
                        name="limit"
                        className="custom-radio-button"
                        value="100"
                        onChange={(e: any) => { props.changePaginationLimit(e.target.value) }}
                    />
                    <label htmlFor="100">100</label>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                    <label style={{ fontWeight: '550', fontSize: '14px' }}>Pagination :</label>
                    <img
                        src={require('../assets/img/prev.png')}
                        alt=""
                        style={{ cursor: 'pointer', marginRight: '5px', marginLeft: '5px' }}
                        onClick={props.prevPage}
                    />

                    <label style={{ fontWeight: '550', fontSize: '14px' }}>{props.limitStart + 1} - {props.limitStart + props.limitSelected}</label>
                    <img
                        src={require('../assets/img/next.svg').default}
                        alt=""
                        style={{ cursor: 'pointer', marginRight: '5px', marginLeft: '5px' }}
                        onClick={props.nextPage}
                    />
                </div>
            </div>
        </div>
    );
};

export default Footer;